/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'cross_product_search_dialog.atlas.tab_label': 'Atlas',
  'cross_product_search_dialog.bitbucket.tab_label': 'Bitbucket',
  'cross_product_search_dialog.confluence.tab_label': 'Confluence',
  'cross_product_search_dialog.google_drive.tab_label': 'Drive',
  'cross_product_search_dialog.google_drive.unauthenticated_prompt':
    'Você pode TRABALHAR em todos os seus slides, documentos, planilhas e outros tipos de arquivos do Google sem sair da Atlassian. Só você tem esse acesso.',
  'cross_product_search_dialog.jira.tab_label': 'Jira',
  'cross_product_search_dialog.opsgenie.tab_label': 'Opsgenie',
  'cross_product_search_dialog.recently_viewed_title': '{sectionTitle} visto por último',
  'cross_product_search_dialog.townsquare_globex_tab_label': 'Página inicial',
  'cross_product_search_dialog.townsquare_recent_goals': 'Objetivos recentes',
  'cross_product_search_dialog.townsquare_recent_help_links': 'Links de ajuda recentes',
  'cross_product_search_dialog.townsquare_recent_learnings_risks_decisions': 'Aprendizados, riscos e decisões recentes',
  'cross_product_search_dialog.townsquare_recent_projects': 'Projetos recentes',
  'cross_product_search_dialog.townsquare_tab_label': 'Atlas',
  'cross_product_search_dialog.trello.tab_label': 'Trello',
  'cross_product_search_dialog.view_all_results_link': 'Ver todos os {sectionTitle}',
  'document-search-result.google-docs-label': 'Documentos',
  'document-search-result.google-sheets-label': 'Fichas',
  'document-search-result.google-slides-label': 'Slides',
  'document-search-result.ms-excel-label': 'Excel',
  'document-search-result.ms-powerpoint-label': 'PowerPoint',
  'document-search-result.ms-word-label': 'Palavra',
  'extensible_search_dialog.advanced_search': 'Pesquisa avançada',
  'extensible_search_dialog.advanced_search_all_apps': 'Pesquisar todos os aplicativos',
  'extensible_search_dialog.connect': 'Conectar',
  'extensible_search_dialog.connect_to': 'Conectar a',
  'extensible_search_dialog.more': '+ mais',
  'global_search.jira.advanced_search_boards': 'Painéis',
  'global_search.jira.advanced_search_filters': 'Filtros',
  'global_search.jira.advanced_search_issues': 'Itens',
  'global_search.jira.advanced_search_issues-issue-term-refresh': 'Tickets',
  'global_search.jira.advanced_search_label': 'Acessar todos:',
  'global_search.jira.advanced_search_people': 'Pessoas',
  'global_search.jira.advanced_search_plans': 'Planos',
  'global_search.jira.advanced_search_projects': 'Projetos',
  'global_search.jira.search_placeholder': 'Pesquisar no Jira',
  'global_search.jira.search_placeholder_experiment_jsw_enabled': 'Pesquise itens, quadros, projetos e filtros',
  'global_search.jira.search_placeholder_experiment_jsw_enabled-issue-term-refresh':
    'Pesquise tickets, quadros, projetos e filtros',
  'product_s earch_dialog.confluence.assignee_filters_find_more': 'Encontrar um responsável',
  'product_search_dialog.atlas.search_input_expanded_placeholder': 'Pesquisar no Atlas',
  'product_search_dialog.autocorrection.label': 'Você quis dizer',
  'product_search_dialog.bitbucket.bitbucket_advanced_search': 'Pesquisar código no {source}',
  'product_search_dialog.bitbucket.bitbucket_recent_repositories': 'Repositórios atualizados por último',
  'product_search_dialog.bitbucket.bitbucket_repositories_section_title': 'Repositórios',
  'product_search_dialog.bitbucket.expanded.input-placeholder': 'Pesquisar no Bitbucket',
  'product_search_dialog.bitbucket.repository_heading': 'Repositórios',
  'product_search_dialog.common.site_filters': 'Filtrar por site',
  'product_search_dialog.compass.component_type.application': 'Aplicativo',
  'product_search_dialog.compass.component_type.capability': 'Capacidade',
  'product_search_dialog.compass.component_type.cloud_resource': 'Recurso de nuvem',
  'product_search_dialog.compass.component_type.data_pipeline': 'Pipeline de dados',
  'product_search_dialog.compass.component_type.library': 'Biblioteca',
  'product_search_dialog.compass.component_type.machine_learning_model': 'Modelo de aprendizado de máquina',
  'product_search_dialog.compass.component_type.other': 'Outros',
  'product_search_dialog.compass.component_type.service': 'Serviço',
  'product_search_dialog.compass.component_type.ui_element': 'Elemento de UI',
  'product_search_dialog.compass.component_type.website': 'Website',
  'product_search_dialog.compass.components_section_heading': 'Componentes',
  'product_search_dialog.compass.endpoints_section_heading': 'Endpoints',
  'product_search_dialog.compass.expanded.input-placeholder': 'Compass de pesquisa',
  'product_search_dialog.compass.people_section_heading': 'Pessoas',
  'product_search_dialog.compass.recently_viewed_components': 'Componentes visualizados há pouco tempo',
  'product_search_dialog.compass.recently_viewed_endpoints': 'Endpoints visualizados por último',
  'product_search_dialog.compass.recently_viewed_teams': 'Equipes visualizadas há pouco tempo',
  'product_search_dialog.compass.tab_label': 'Compass',
  'product_search_dialog.compass.teams_section_heading': 'Equipes',
  'product_search_dialog.compass.upsell_modal_cta_text': 'Obtenha o Compass grátis',
  'product_search_dialog.compass.upsell_modal_description':
    'Catalogue a arquitetura de software em um só lugar para que as equipes que trabalham nela possam reduzir a troca de contexto, encontrar o que precisam com mais rapidez e serem mais produtivas. Que tal ter essa experiência de desenvolvedor?',
  'product_search_dialog.compass.upsell_modal_description.bitbucket':
    'Vincule os repositórios a um catálogo central de software para ver proprietários, dependências e recursos de ajuda.',
  'product_search_dialog.compass.upsell_modal_heading':
    'Controle o crescimento do software para que os desenvolvedores consigam controlar o tempo',
  'product_search_dialog.compass.upsell_modal_heading.bitbucket': 'Dê mais contexto para o código',
  'product_search_dialog.compass.upsell_modal_learn_more_aria_label': 'Saiba mais sobre o Compass',
  'product_search_dialog.compass.upsell_modal_learn_more_link': 'Saiba mais',
  'product_search_dialog.compass.upsell_tab_title_lozenge': 'Novo',
  'product_search_dialog.compass.view_all_components_label': 'Exibir todos os componentes',
  'product_search_dialog.compass.view_all_results_label': 'Exibir todos os resultados',
  'product_search_dialog.confluence.advanced_search_with_product_prefix': 'Pesquisa avançada do Confluence',
  'product_search_dialog.confluence.clear_filters': 'Limpar filtros',
  'product_search_dialog.confluence.confluence_availability_in_jira_search.description':
    'Sua equipe está colaborando no Confluence. Organize o conhecimento da equipe, colete ideias e compartilhe requisitos para os projetos do Jira com páginas, quadros brancos e bancos de dados.',
  'product_search_dialog.confluence.confluence_availability_in_jira_search.header': 'A equipe está usando o Confluence',
  'product_search_dialog.confluence.confluence_availability_in_jira_search.join_button': 'Entrar na equipe',
  'product_search_dialog.confluence.confluence_availability_in_jira_search.learn_more_button': 'Saiba mais',
  'product_search_dialog.confluence.confluence_availability_in_jira_search.tab.more_results': 'Mais resultados',
  'product_search_dialog.confluence.confluence_reactivation_experiment.inactive_user': 'Mais resultados',
  'product_search_dialog.confluence.confluence_reactivation_experiment.never_active_user': 'Acesso grátis',
  'product_search_dialog.confluence.content_section_heading': 'Conteúdo',
  'product_search_dialog.confluence.contributor_filters': 'Filtrar por colaborador',
  'product_search_dialog.confluence.contributor_filters_find_more': 'Encontrar um colaborador',
  'product_search_dialog.confluence.date_filter_title': 'Última atualização',
  'product_search_dialog.confluence.date_filter_today': 'Hoje',
  'product_search_dialog.confluence.date_filter_yesterday': 'Ontem',
  'product_search_dialog.confluence.date_filters_any': 'Todas as datas',
  'product_search_dialog.confluence.date_filters_month': 'Últimos 30 dias',
  'product_search_dialog.confluence.date_filters_week': 'Últimos 7 dias',
  'product_search_dialog.confluence.date_filters_year': 'Ano passado',
  'product_search_dialog.confluence.empty_state_body_no_advanced_search':
    'Tente procurar menos palavras-chave, palavras-chave diferentes ou mais gerais.',
  'product_search_dialog.confluence.empty_state_body_prequery_filters':
    'Não encontramos nada criado ou atualizado nos últimos 90 dias com os filtros selecionados.',
  'product_search_dialog.confluence.empty_state_body_title':
    'Não foi possível encontrar correspondências para a pesquisa.',
  'product_search_dialog.confluence.filters_applied': 'Parece que alguns filtros foram aplicados',
  'product_search_dialog.confluence.pages_blogs_attachments_section_heading': 'Páginas, blogs e anexos',
  'product_search_dialog.confluence.people_section_heading': 'Pessoas',
  'product_search_dialog.confluence.search_input_expanded_placeholder': 'Pesquisar no Confluence',
  'product_search_dialog.confluence.search_input_expanded_placeholder_ai': 'Pesquise ou faça perguntas no Confluence',
  'product_search_dialog.confluence.space_filters': 'Filtrar por espaço',
  'product_search_dialog.confluence.space_filters_find_more': 'Encontrar um espaço',
  'product_search_dialog.confluence.spaces_section_heading': 'Espaços',
  'product_search_dialog.confluence.typing_state_header_text': 'Pesquisar conteúdo no Confluence',
  'product_search_dialog.cross_product.empty.no_results_body':
    '<a>Pesquise todo o conteúdo em sua organização</a> ou tente um termo diferente.',
  'product_search_dialog.cross_product.expanded.input-placeholder': 'Pesquisar todos os',
  'product_search_dialog.cross_product.recents.section_heading': 'Visto por último',
  'product_search_dialog.cross_product.results.section_heading': 'Resultados da pesquisa',
  'product_search_dialog.cross_product.tab_label': 'Todos',
  'product_search_dialog.empty.no_results_body':
    'Tente outra vez com um termo diferente ou refine os resultados com a <a>Pesquisa avançada</a>',
  'product_search_dialog.empty.no_results_body_with_no_advanced_search': 'Tente de novo usando outro termo.',
  'product_search_dialog.empty.no_results_heading': 'Não encontramos nenhum resultado para sua pesquisa.',
  'product_search_dialog.empty_prequery.error_heading': 'Algo deu errado ao mostrar os resultados iniciais',
  'product_search_dialog.empty_prequery.no_results_heading': 'Procure o que você precisa',
  'product_search_dialog.error.failed_loading_search_body':
    'Pode ser apenas um contratempo. Atualize a página ou <emptyLink>tente de novo.</emptyLink>',
  'product_search_dialog.error.failed_loading_search_heading':
    'Ocorreram alguns problemas ao carregar o conteúdo visto recentemente.',
  'product_search_dialog.give_feedback': 'Enviar feedback',
  'product_search_dialog.google_drive.files_heading': 'Arquivos',
  'product_search_dialog.inline_onboarding_action': 'Ok',
  'product_search_dialog.inline_onboarding_body':
    'Utilize as guias do Jira e do Confluence para pesquisar e visualizar itens recentes nos dois locais.',
  'product_search_dialog.inline_onboarding_title': 'Pesquisar no Jira e no Confluence',
  'product_search_dialog.jira.assignee_filters': 'Filtrar por responsável',
  'product_search_dialog.jira.boards_icon_accessibility_text': 'Ícone do quadro',
  'product_search_dialog.jira.boards_projects_filters_plans_section_heading': 'Quadros, projetos, filtros e planos',
  'product_search_dialog.jira.boards_projects_filters_section_heading': 'Quadros, projetos e filtros',
  'product_search_dialog.jira.date_filter_30': '30 dias',
  'product_search_dialog.jira.date_filter_60': '60 dias',
  'product_search_dialog.jira.date_filter_90': '90 dias',
  'product_search_dialog.jira.date_filter_any': 'A qualquer momento',
  'product_search_dialog.jira.date_filter_past_30_days': 'Últimos 30 dias',
  'product_search_dialog.jira.date_filter_past_7_days': 'Últimos 7 dias',
  'product_search_dialog.jira.date_filter_past_year': 'Ano passado',
  'product_search_dialog.jira.date_filter_today': 'Hoje',
  'product_search_dialog.jira.date_filter_yesterday': 'Ontem',
  'product_search_dialog.jira.date_filters': 'Última atualização',
  'product_search_dialog.jira.empty_prequery.no_results_heading': 'Comece a pesquisar para encontrar o trabalho',
  'product_search_dialog.jira.issue_filter_done': 'Concluído',
  'product_search_dialog.jira.issue_filter_open': 'Abrir',
  'product_search_dialog.jira.issue_filters': 'Filtrar por status',
  'product_search_dialog.jira.issue_labels_filters': 'Filtrar por categoria',
  'product_search_dialog.jira.issue_labels_filters_options_group_label': 'Todas as categorias',
  'product_search_dialog.jira.issue_labels_filters_placeholder': 'Selecionar categoria',
  'product_search_dialog.jira.issues_section_heading': 'Itens',
  'product_search_dialog.jira.issues_section_heading-issue-term-refresh': 'Tickets',
  'product_search_dialog.jira.jira_view_all_issues_new': 'Ver todos os itens',
  'product_search_dialog.jira.jira_view_all_issues_new-issue-term-refresh': 'Ver todos os tickets',
  'product_search_dialog.jira.project_filters': 'Filtrar por projeto',
  'product_search_dialog.jira.project_filters_find_more': 'Encontrar um projeto',
  'product_search_dialog.jira.projects_filters_section_heading': 'Projetos e filtros',
  'product_search_dialog.jira.recent_boards_projects_filters_plans_section_heading':
    'Quadros, projetos, filtros e planos recentes',
  'product_search_dialog.jira.recent_boards_projects_filters_section_heading': 'Quadros, projetos e filtros recentes',
  'product_search_dialog.jira.recent_projects_filters_section_heading': 'Projetos e filtros recentes',
  'product_search_dialog.jira.recently_viewed_issues_section_heading': 'Itens vistos recentemente',
  'product_search_dialog.jira.recently_viewed_issues_section_heading-issue-term-refresh':
    'Tickets visualizados há pouco tempo',
  'product_search_dialog.jira.report_by_filters': 'Filtrar por relator',
  'product_search_dialog.jira.reported_by_me_filter': 'Relatados por mim',
  'product_search_dialog.jira.site_filters_find_more': 'Encontrar um site',
  'product_search_dialog.loading_filters': 'Carregando',
  'product_search_dialog.more_filters': 'Visualizar todos os filtros',
  'product_search_dialog.multi_site_advanced_search_label': 'Pesquisar em:',
  'product_search_dialog.multi_site_advanced_search_more_dropdown': '{count} mais',
  'product_search_dialog.no_options_filters': 'Nenhuma opção',
  'product_search_dialog.opsgenie.advanced_search': 'Pesquisa avançada de alertas',
  'product_search_dialog.opsgenie.alert_heading': 'Alertas',
  'product_search_dialog.opsgenie.expanded.input-placeholder': 'Pesquisar no Opsgenie',
  'product_search_dialog.opsgenie.opsgenie_recent_alerts': 'Alertas recentes',
  'product_search_dialog.quick_find_ask_atlassian_intelligence': 'Pergunte ao Atlassian Intelligence',
  'product_search_dialog.quick_find_confluence_space': 'Espaço do Confluence',
  'product_search_dialog.quick_find_footer_full_page_search_products_link': 'Pesquisar nos produtos',
  'product_search_dialog.quick_find_footer_help_text': 'Ajude a gente a melhorar a pesquisa',
  'product_search_dialog.quick_find_no_content_body_rovo':
    'Pesquise ou pergunte ao Rovo sobre o que você está procurando nos produtos da Atlassian e produtos integrados',
  'product_search_dialog.quick_find_no_content_header': 'Quem procura acha',
  'product_search_dialog.quick_find_post_query_no_results_body':
    '<SearchContentLink>Pesquise todo o conteúdo em sua organização</SearchContentLink> ou tente de novo com um termo diferente.',
  'product_search_dialog.quick_find_post_query_no_results_header':
    'Não foi possível encontrar nenhum resultado com esse título',
  'product_search_dialog.quick_find_recent_draft_label': 'RASCUNHO',
  'product_search_dialog.quick_find_recent_search': 'Pesquisa recente',
  'product_search_dialog.quick_find_recent_search_text_dialog': 'Das pesquisas recentes',
  'product_search_dialog.quick_find_recent_spaces_additional_meta': 'Acessados há pouco tempo',
  'product_search_dialog.quick_find_recently_viewed': 'Visualizado por último',
  'product_search_dialog.quick_find_result_item_team': 'Equipe',
  'product_search_dialog.quick_find_results_section': 'Resultados da pesquisa',
  'product_search_dialog.quick_find_rovo_tip':
    'Insira uma pergunta como "Qual é a política de férias?" e o Rovo vai encontrar a resposta.',
  'product_search_dialog.quick_find_search_input_rovo_placeholder': 'Pesquise ou pergunte ao Rovo',
  'product_search_dialog.quick_find_search_results': 'Resultados da pesquisa',
  'product_search_dialog.quick_find_show_filtered_confluence_results':
    'Filtrar por espaços do Confluence, contribuidores e muito mais',
  'product_search_dialog.quick_find_show_filtered_confluence_results_with_icon':
    'Filtrar por {confluenceIcon} espaços do Confluence, contribuidores e muito mais',
  'product_search_dialog.quick_find_show_organization_results': 'Pesquisar sua organização',
  'product_search_dialog.recent_spaces_section_heading': 'Espaços recentes',
  'product_search_dialog.recently_viewed_heading': 'Pesquisa avançada',
  'product_search_dialog.recently_viewed_section_heading': 'Visto por último',
  'product_search_dialog.recently_worked_with_section_heading': 'Recentemente trabalhou com',
  'product_search_dialog.results.remove_button_label': 'Remova isso.',
  'product_search_dialog.search_input_collapsed_placeholder': 'Pesquisar',
  'product_search_dialog.search_input_enlarged_aria_label': 'Pressione Enter para acessar a pesquisa avançada',
  'product_search_dialog.search_people_link': 'Procurar pessoas',
  'product_search_dialog.show_all_results_link': 'Visualize todos os resultados',
  'product_search_dialog.show_more_results_link': 'Ver mais',
  'product_search_dialog.townsquare.search_input_expanded_placeholder': 'Pesquisar na página inicial',
  'product_search_dialog.townsquare_goals_heading': 'Objetivos',
  'product_search_dialog.townsquare_goals_view_all': 'Pesquisar em todas as metas',
  'product_search_dialog.townsquare_help_links_heading': 'Links de ajuda',
  'product_search_dialog.townsquare_learnings_risks_decisions_heading': 'Aprendizados, riscos e decisões',
  'product_search_dialog.townsquare_people_heading': 'Pessoas',
  'product_search_dialog.townsquare_people_view_all': 'Pesquise em todas as pessoas',
  'product_search_dialog.townsquare_projects_heading': 'Projetos',
  'product_search_dialog.townsquare_projects_view_all': 'Pesquisar em todos os projetos',
  'product_search_dialog.townsquare_recent_people': 'Pessoas recentes',
  'product_search_dialog.townsquare_recent_topics': 'Tópicos recentes',
  'product_search_dialog.townsquare_teams_heading': 'Equipes',
  'product_search_dialog.townsquare_teams_view_all': 'Pesquisar em todas as equipes',
  'product_search_dialog.townsquare_topics_heading': 'Tópicos',
  'product_search_dialog.townsquare_topics_view_all': 'Pesquisar em todos os tópicos',
  'product_search_dialog.trello.archived': 'Arquivado',
  'product_search_dialog.trello.archived.card-hover': 'Este cartão está arquivado',
  'product_search_dialog.trello.board': 'Quadro',
  'product_search_dialog.trello.boards_heading': 'Painéis',
  'product_search_dialog.trello.cards_heading': 'Cartões',
  'product_search_dialog.trello.closed': 'Fechado',
  'product_search_dialog.trello.closed.board-hover': 'Este quadro está fechado',
  'product_search_dialog.trello.expanded.input-placeholder': 'Pesquisar no Trello',
  'product_search_dialog.trello.feedback_link': 'Nos ajude a melhorar seus resultados de pesquisa!',
  'product_search_dialog.trello.list': 'Lista',
  'product_search_dialog.trello.private_workspace': 'Área de trabalho privada',
  'product_search_dialog.trello.recent_boards_heading': 'Quadros recentes',
  'product_search_dialog.trello.workspace': 'Área de trabalho',
  'product_search_dialog.updated_date_formatter': 'Atualizado em {date}',
  'search_dialog.filters.group.show-more': 'Ver mais',
  'search_dialog.search_input_clear_label': 'Limpar sessão de pesquisa',
  'search_dialog.search_input_exit_label': 'Sair da pesquisa',
};
